import { Invitee } from '@/models/Invitation';

export const getInviteeCodeDisplay = (invitee: Invitee): string => invitee.affiliateCode || invitee.inviteCode || '-';

export const getInviteeNotesDisplay = (invitee: Invitee, affiliateProgramLabel: string): string => (
  invitee.affiliateCode ? affiliateProgramLabel : invitee.userNote || '-'
);

export const getInviteeDisplayValue = (
  fieldName: string,
  invitee: Invitee,
  affiliateProgramLabel: string,
): Invitee | string => {
  switch (fieldName) {
    case 'user': return invitee.invitedUserId;
    case 'notes': return getInviteeNotesDisplay(invitee, affiliateProgramLabel);
    case 'code': return getInviteeCodeDisplay(invitee);
    default: return invitee;
  }
};
